//	Convert a server timestamp to unix timestamp, or return to sender, if it isn't a server timestamp.
const serverTimestamp = sts => sts && ((sts._seconds || sts.seconds) ? ((sts._seconds || sts.seconds || 0) * 1000) + parseInt((sts._nanoseconds || sts.nanoseconds || 0) / 1000000, 10) : sts) // eslint-disable-line no-underscore-dangle

export default serverTimestamp



// WEBPACK FOOTER //
// ./src/utilities/Data/serverTimestamp.js